import { SafeHtml } from '../../../../../node_modules/@angular/platform-browser';
import { Url } from 'url';
import { PromoType } from './promoType';
import { dateCheck } from '../../lib/helpers/utils';

export interface TramoPromo {
    tramo: number;
    descripcion: string;
    unidades: number;
    porcentaje: number;
}
export interface Promo {
    descripcionTotalConseguido: string;
    descripcionTotalSiguiente: string;
    fechaDesde: string;
    fechaHasta: string;
    htmlDescripcion: string;
    idPromo: number;
    importeActual: number;
    importeConseguido: number;
    importeSiguiente: number;
    jsonTramos: TramoPromo[];
    promoConseguida: SafeHtml;
    promoSiguiente: SafeHtml;
    titulo: SafeHtml;
    tipoPromo: PromoType;
    tramoConseguido: number;
    tramoSiguiente: number;
    unidadesActual: number;
    unidadesConseguidas: number;
    unidadesTotalesTramos: number;
    unidadesSiguiente: number;
    urlIcono: Url;
    urlImagen: Url;
    urlLista: Url;
    urlBanner: Url;
    nivelCompleto: number;
    tieneRegalos: boolean;
    esTrimestreActual: boolean;
    nombrePuntosConseguidos: string;
    porcentaje: number;
    ocultarTotalEnBarra: boolean;
}

export class PromoHelper {
    static create(): Promo {
        return {
            descripcionTotalConseguido: undefined,
            descripcionTotalSiguiente: undefined,
            fechaDesde: undefined,
            fechaHasta: undefined,
            htmlDescripcion: undefined,
            idPromo: undefined,
            importeActual: undefined,
            importeConseguido: undefined,
            importeSiguiente: undefined,
            jsonTramos: [],
            promoConseguida: undefined,
            promoSiguiente: undefined,
            titulo: undefined,
            tipoPromo: undefined,
            tramoConseguido: undefined,
            tramoSiguiente: undefined,
            unidadesActual: undefined,
            unidadesConseguidas: undefined,
            unidadesTotalesTramos: undefined,
            unidadesSiguiente: undefined,
            urlIcono: undefined,
            urlImagen: undefined,
            urlLista: undefined,
            urlBanner: undefined,
            nivelCompleto: undefined,
            tieneRegalos: undefined,
            esTrimestreActual: false,
            nombrePuntosConseguidos: 'unidades',
            porcentaje: 0,
            ocultarTotalEnBarra: false,
        };
    }

    static transformFromApi(apiData: Object): Promo {
        const promo = PromoHelper.create();
        promo.descripcionTotalConseguido = apiData['DESCRIPCION_TOTAL_CONSEGUIDO'] || '';
        promo.descripcionTotalSiguiente = apiData['DESCRIPCION_TOTAL_SIGUIENTE'] || '';
        // dateString = '1968-11-16T00:00:00'
        // apidata.replace(/(\d{4})(\d{2})(\d{2})/, "$1-$2-$3")+'T00:00:00';
        promo.fechaDesde = apiData['FECHADESDE']
            ? apiData['FECHADESDE'].toString().replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + 'T00:00:00'
            : '';
        promo.fechaHasta = apiData['FECHAHASTA']
            ? apiData['FECHAHASTA'].toString().replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + 'T00:00:00'
            : '';
        promo.htmlDescripcion = apiData['HTML_DESCRIPCION'] || '';
        promo.idPromo = apiData['IDPROMO'];
        promo.importeActual = apiData['IMPORTE_ACTUAL'] || 0;
        promo.importeConseguido = apiData['IMPORTE_CONSEGUIDO'] || 0;
        promo.importeSiguiente = apiData['IMPORTE_SIGUIENTE'] || 0;
        promo.unidadesActual = apiData['UNIDADES_ACTUAL'] || 0;
        promo.unidadesConseguidas = apiData['UNIDADES_CONSEGUIDAS'] || 0;
        promo.unidadesSiguiente =
            typeof apiData['UNIDADES_SIGUIENTE'] === 'number'
                ? apiData['UNIDADES_SIGUIENTE']
                : promo.unidadesConseguidas;
        promo.ocultarTotalEnBarra = typeof apiData['UNIDADES_SIGUIENTE'] !== 'number';
        promo.promoConseguida = apiData['PROMO_CONSEGUIDA'] || '';
        promo.promoSiguiente = apiData['PROMO_SIGUIENTE'] || '';
        promo.nombrePuntosConseguidos = apiData['NOMBRE_PUNTOS_CONSEGUIDOS']
            ? apiData['NOMBRE_PUNTOS_CONSEGUIDOS'].toLowerCase()
            : 'unidades';
        promo.jsonTramos = [];
        let tramos: TramoPromo[] = JSON.parse(apiData['JSON_TRAMOS']);
        if (tramos.length) {
            const udsArr = tramos.map((t) => t.unidades);
            promo.unidadesTotalesTramos = udsArr.reduce((a, b) => Math.max(a, b), 0);
            tramos = tramos.map((t, index) => {
                t.descripcion = t.descripcion.replace('Rappel ', '');
                // porcentaje según unidades de cada tramo
                t.porcentaje =
                    promo.unidadesTotalesTramos > 0 ? Math.ceil((t.unidades / promo.unidadesTotalesTramos) * 100) : 0;
                // mismo porcentaje para cada barra independientemente de sus unidades
                t.porcentaje = ((index + 1) * 100) / tramos.length;
                return t;
            });
            promo.jsonTramos = tramos;
        } else {
            promo.unidadesTotalesTramos = promo.unidadesSiguiente;
            const porcentaje =
                promo.unidadesTotalesTramos > 0
                    ? Math.ceil((promo.unidadesSiguiente / promo.unidadesTotalesTramos) * 100)
                    : 0;
            let descripcion: any = promo.promoSiguiente ? promo.promoSiguiente.toString().match(/-?\d+\.?\d*/) : '';
            descripcion = descripcion ? descripcion.toString() + ' €' : '';
            promo.jsonTramos = [
                {
                    tramo: 1,
                    unidades: promo.unidadesSiguiente,
                    descripcion,
                    porcentaje,
                },
            ];
        }
        promo.titulo = apiData['TITULO'] || '';
        promo.tipoPromo = apiData['TIPOPROMO'];
        promo.tramoConseguido = apiData['TRAMO_CONSEGUIDO'] || 0;
        promo.tramoSiguiente = apiData['TRAMO_SIGUIENTE'] || 0;
        promo.urlIcono = apiData['URL_ICONO'] || '';
        promo.urlImagen = apiData['URL_IMAGEN'] || '';
        promo.urlLista = apiData['URL_LISTA'] || '';
        promo.urlBanner = apiData['URL_BANNER'] || '';
        promo.nivelCompleto = apiData['NIVEL_CONSEGUIDO'] || 0;
        promo.tieneRegalos = apiData['TIENE_REGALOS'];
        promo.esTrimestreActual = dateCheck(promo.fechaDesde, promo.fechaHasta, new Date());
        promo.porcentaje = promo.unidadesSiguiente > 0 ? (promo.unidadesActual / promo.unidadesSiguiente) * 100 : 100;

        return promo;
    }

    static getLevel(promo: Promo): string {
        return promo.nivelCompleto.toString();
    }

    static getActual(promo: Promo): string {
        return promo.unidadesActual.toString();
    }
    static getSiguiente(promo: Promo): string {
        return promo.unidadesSiguiente.toString();
    }
}
